import type { ReportElementType } from '@highimpact-frontend/api-types';

import type { ResolveReportExportDisplayNameContext } from './types';

/** Default display-name resolver for report gather progress UI. */
export function resolveReportExportDisplayName(
  element: ReportElementType,
  ctx: ResolveReportExportDisplayNameContext
): string {
  const live = ctx.getWidgetByTemplateVariable(element.template_variable);
  const liveName = live?.elementData.name?.trim();
  const reportName = element.name?.trim();
  return liveName || reportName || element.template_variable;
}
